var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ProductValidationHeader } from 'components/ProductValidation/ProductValidationHeader/ProductValidationHeader';
import { ValidationFeatureGrid } from 'components/ProductValidation/ValidationFeatureGrid/ValidationFeatureGrid';
import { REQUEST_TYPE_ORDER, REQUEST_TYPE_QUOTE } from 'utils/constants';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { StyledButton } from 'components/Shared/StyledComponents/StyledButton';
import { StyledSearchWithDateAndTimeInput } from 'components/Shared/StyledComponents/StyledSearchWithDateAndTimeInput/StyledSearchWithDateAndTimeInput';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import { createContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { info, validate } from 'services/api/product-service';
import { toUTCTimestamp } from 'services/helperFunctions/toUTCTimestamp';
import { replaceProductNbrPlaceholder, validateRangeInput } from 'utils/productBuildHelper';
import styles from './ProductBuildDetailPage.module.scss';
export function ProductBuildDetailPage() {
    var _this = this;
    var location = useLocation();
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    var productIdFromSearchParams = searchParams.get('productId');
    var productNoFromSearchParams = searchParams.get('productNo');
    var _a = useState(''), searchText = _a[0], setSearchText = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), isAutoBuild = _c[0], setIsAutoBuild = _c[1];
    var isProductNumber = productNoFromSearchParams !== null;
    var isProductId = productIdFromSearchParams !== null;
    var _d = useState(''), productNumber = _d[0], setProductNumber = _d[1];
    var _e = useState(), productId = _e[0], setProductId = _e[1];
    var _f = useState(''), erroredSearchText = _f[0], setErroredSearchText = _f[1];
    var defaultBuildErrorMessage = 'Product Build encountered an error - please click the reset button to start over.';
    var _g = useState(), selectableFeatureOptions = _g[0], setSelectableFeatureOptions = _g[1];
    useEffect(function () {
        var searchTerm = sessionStorage.getItem('searchTerm');
        if (!searchTerm || searchTerm === '') {
            if (productNoFromSearchParams) {
                sessionStorage.setItem('searchTerm', productNoFromSearchParams);
            }
            else if (productIdFromSearchParams) {
                sessionStorage.setItem('searchTerm', productIdFromSearchParams);
            }
        }
    }, [productIdFromSearchParams, productNoFromSearchParams]);
    // eslint-disable-next-line react-hooks/exhaustive-deps, consistent-return
    var getProductPrefix = function () { return __awaiter(_this, void 0, void 0, function () {
        var productInfo;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!(productId && !productNumber)) return [3 /*break*/, 2];
                    setIsLoading(true);
                    return [4 /*yield*/, info({ productId: productId })];
                case 1:
                    productInfo = _j.sent();
                    setProductNumber((_c = (_b = (_a = productInfo.body.details) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.prefix) !== null && _c !== void 0 ? _c : '');
                    setSearchText((_f = (_e = (_d = productInfo.body.details) === null || _d === void 0 ? void 0 : _d.header) === null || _e === void 0 ? void 0 : _e.prefix) !== null && _f !== void 0 ? _f : '');
                    setIsLoading(false);
                    return [2 /*return*/, (_h = (_g = productInfo.body.details) === null || _g === void 0 ? void 0 : _g.header) === null || _h === void 0 ? void 0 : _h.prefix];
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!searchText) {
            if (!isProductNumber && isProductId) {
                setProductId(productIdFromSearchParams);
                getProductPrefix();
            }
            else if (isProductNumber && !isProductId) {
                setProductNumber(productNoFromSearchParams);
                setSearchText(productNoFromSearchParams);
            }
            else if (isProductNumber && isProductId) {
                setProductNumber(productNoFromSearchParams);
                setProductId(productIdFromSearchParams);
                setSearchText(productNoFromSearchParams);
            }
        }
    }, [
        getProductPrefix,
        isProductId,
        isProductNumber,
        location.search,
        productIdFromSearchParams,
        productNoFromSearchParams,
        searchText,
    ]);
    var _h = useState(), validationData = _h[0], setValidationData = _h[1];
    var _j = useState([]), productBuildFeatureOptionSelections = _j[0], setProductBuildFeatureOptionSelections = _j[1];
    var _k = useState(false), disableSubmit = _k[0], setDisableSubmit = _k[1];
    var _l = useState(false), textFieldIsInError = _l[0], setTextFieldIsInError = _l[1];
    var _m = useState(), timestampData = _m[0], setTimestampData = _m[1];
    var _o = useState(false), showProductData = _o[0], setShowProductData = _o[1];
    var _p = useState(false), enableReset = _p[0], setEnableReset = _p[1];
    var _q = useState(false), isProductBuildInError = _q[0], setIsProductBuildInError = _q[1];
    useEffect(function () {
        if (searchText === productNumber && (productBuildFeatureOptionSelections === null || productBuildFeatureOptionSelections === void 0 ? void 0 : productBuildFeatureOptionSelections.length) === 0) {
            setEnableReset(false);
        }
        else {
            setEnableReset(true);
        }
    }, [productBuildFeatureOptionSelections === null || productBuildFeatureOptionSelections === void 0 ? void 0 : productBuildFeatureOptionSelections.length, productNumber, searchText]);
    useEffect(function () {
        if (productBuildFeatureOptionSelections.length > 0) {
            setEnableReset(true);
        }
    }, [productBuildFeatureOptionSelections]);
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var fetchProductNumberData = function (_a) {
        var timestamp = _a.timestamp, passedProductNumber = _a.passedProductNumber, passedFeatureSelections = _a.passedFeatureSelections;
        return __awaiter(_this, void 0, void 0, function () {
            var apiData, data, errorMessage, newNext_1;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            return __generator(this, function (_p) {
                switch (_p.label) {
                    case 0:
                        setShowProductData(true);
                        setIsLoading(true);
                        apiData = {
                            productNbr: passedProductNumber !== null && passedProductNumber !== void 0 ? passedProductNumber : searchText,
                            requestType: REQUEST_TYPE_QUOTE,
                            processingDate: timestamp,
                            returnNextFeature: true,
                            featureSelections: passedFeatureSelections,
                        };
                        if (isProductId) {
                            apiData.productId = productId;
                        }
                        return [4 /*yield*/, validate(apiData)];
                    case 1:
                        data = _p.sent();
                        if (data) {
                            setIsLoading(false);
                            if (data.status !== 200) {
                                errorMessage = (_b = data.body.message) !== null && _b !== void 0 ? _b : 'Validate Error';
                                setErroredSearchText(errorMessage);
                                setSnackbarAlert({
                                    message: errorMessage,
                                    type: 'error',
                                });
                                setIsProductBuildInError(true);
                                setEnableReset(true);
                                return [2 /*return*/];
                            }
                            if (data.body.returnCode === '-2') {
                                setIsProductBuildInError(false);
                            }
                            if (data.body.returnCode === '-1') {
                                if ((isProductNumber && !isProductId) || (isProductNumber && isProductId)) {
                                    setSearchText(productNumber);
                                    setProductBuildFeatureOptionSelections([]);
                                }
                                else if (!isProductNumber && !isProductId) {
                                    setSearchText('');
                                }
                                else if (!isProductNumber && isProductId) {
                                    setSearchText(productNumber);
                                }
                                setIsProductBuildInError(true);
                                setEnableReset(true);
                                setSnackbarAlert({
                                    message: (_d = (_c = data.body) === null || _c === void 0 ? void 0 : _c.returnMessage) !== null && _d !== void 0 ? _d : defaultBuildErrorMessage,
                                    type: 'error',
                                });
                            }
                            setValidationData(data);
                            if ((_f = (_e = validationData === null || validationData === void 0 ? void 0 : validationData.body) === null || _e === void 0 ? void 0 : _e.nextFeature) === null || _f === void 0 ? void 0 : _f.options) {
                                newNext_1 = {
                                    key: (_h = (_g = (validationData === null || validationData === void 0 ? void 0 : validationData.body).nextFeature) === null || _g === void 0 ? void 0 : _g.featureId) !== null && _h !== void 0 ? _h : '',
                                    options: (_l = (_k = (_j = validationData === null || validationData === void 0 ? void 0 : validationData.body) === null || _j === void 0 ? void 0 : _j.nextFeature) === null || _k === void 0 ? void 0 : _k.options) !== null && _l !== void 0 ? _l : [],
                                };
                            }
                            // eslint-disable-next-line consistent-return
                            setSelectableFeatureOptions(function (prevVal) {
                                // this is for the select dropdown
                                var selectableFeaturesAndOptions = [];
                                prevVal === null || prevVal === void 0 ? void 0 : prevVal.forEach(function (item) {
                                    if (item !== undefined) {
                                        selectableFeaturesAndOptions.push(item);
                                    }
                                });
                                return __spreadArray(__spreadArray([], selectableFeaturesAndOptions, true), [newNext_1], false);
                            });
                            if (((_m = data.body) === null || _m === void 0 ? void 0 : _m.returnCode) &&
                                ((_o = data.body) === null || _o === void 0 ? void 0 : _o.returnCode) === '0') {
                                setSnackbarAlert({
                                    message: 'Product Build complete',
                                    type: 'success',
                                });
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleInputValueChange = function (value) {
        setSearchText(value);
        setDisableSubmit(false);
        setTextFieldIsInError(false);
    };
    var handleButtonClick = function (_a) {
        var _b;
        var timestamp = _a.timestamp;
        var newParsedTimeStamp = toUTCTimestamp(timestamp);
        setIsAutoBuild(false);
        setProductBuildFeatureOptionSelections([]);
        sessionStorage.removeItem('tableData');
        setTimestampData(newParsedTimeStamp.parsedTimeStamp);
        setProductNumber(searchText);
        fetchProductNumberData({ timestamp: (_b = newParsedTimeStamp.parsedTimeStamp) !== null && _b !== void 0 ? _b : '' });
    };
    var handleFeatureBuildOptionClick = function (featureOption, featureId) {
        var _a;
        var selectedFeature = {
            featureId: featureId,
            optionCode: featureOption.optionCode,
        };
        sessionStorage.removeItem('tableData');
        setProductBuildFeatureOptionSelections(function (prevVal) {
            fetchProductNumberData({
                timestamp: timestampData !== null && timestampData !== void 0 ? timestampData : '',
                passedProductNumber: featureOption.productNbr,
                passedFeatureSelections: __spreadArray(__spreadArray([], prevVal, true), [selectedFeature], false),
            });
            return __spreadArray(__spreadArray([], prevVal, true), [selectedFeature], false);
        });
        setProductNumber((_a = featureOption.productNbr) !== null && _a !== void 0 ? _a : '');
    };
    var handleProductBuildResetClick = function (timestamp) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            sessionStorage.removeItem('tableData');
            setShowProductData(false);
            setSelectableFeatureOptions([]);
            setProductBuildFeatureOptionSelections([]);
            setIsProductBuildInError(false);
            if (!isProductId && isProductNumber) {
                setSearchText(productNumber);
                fetchProductNumberData({ timestamp: timestamp, passedProductNumber: searchText });
                return [2 /*return*/];
            }
            if (!isProductId && !isProductNumber) {
                setSearchText('');
            }
            if (isProductId && !isProductNumber) {
                setProductNumber(searchText);
                fetchProductNumberData({ timestamp: timestamp, passedProductNumber: searchText });
            }
            if (productId && productNumber) {
                setSearchText(searchText);
                setProductNumber(searchText);
                fetchProductNumberData({ timestamp: timestamp, passedProductNumber: searchText });
            }
            return [2 /*return*/];
        });
    }); };
    var beginAutoBuild = function (_a) {
        var passedProductNumber = _a.passedProductNumber, featureSelections = _a.featureSelections, passedOption = _a.passedOption, val = _a.val;
        return __awaiter(_this, void 0, void 0, function () {
            var apiData, data, newNext, storedData, parsedStorage;
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        setShowProductData(true);
                        setIsLoading(true);
                        apiData = {
                            productNbr: passedProductNumber !== null && passedProductNumber !== void 0 ? passedProductNumber : searchText,
                            requestType: REQUEST_TYPE_ORDER,
                            processingDate: timestampData,
                            returnNextFeature: true,
                            featureSelections: featureSelections,
                        };
                        if (isProductId) {
                            apiData.productId = productId;
                        }
                        return [4 /*yield*/, validate(apiData)];
                    case 1:
                        data = _g.sent();
                        if (data.body.returnCode === '0') {
                            setIsAutoBuild(false);
                            setSnackbarAlert({
                                message: "Product Build completed with option '".concat(passedOption.optionCode, "'"),
                                type: 'success',
                            });
                            setIsProductBuildInError(false);
                        }
                        if (data.body.returnCode === '-1' || data.status !== 200) {
                            setIsAutoBuild(false);
                            setSnackbarAlert({
                                message: (_b = data.body.returnMessage) !== null && _b !== void 0 ? _b : defaultBuildErrorMessage,
                                type: 'error',
                            });
                            setEnableReset(true);
                            setIsProductBuildInError(true);
                            return [2 /*return*/];
                        }
                        setValidationData(data);
                        newNext = {
                            key: (_d = (_c = data.body) === null || _c === void 0 ? void 0 : _c.nextFeature) === null || _d === void 0 ? void 0 : _d.featureId,
                            options: (_f = (_e = data.body) === null || _e === void 0 ? void 0 : _e.nextFeature) === null || _f === void 0 ? void 0 : _f.options,
                        };
                        storedData = sessionStorage.getItem('tableData');
                        parsedStorage = JSON.parse(storedData);
                        setSelectableFeatureOptions(function () {
                            var newArrayOfSelectables = [];
                            selectableFeatureOptions === null || selectableFeatureOptions === void 0 ? void 0 : selectableFeatureOptions.forEach(function (selectable) {
                                var _a;
                                (_a = data.body.features) === null || _a === void 0 ? void 0 : _a.forEach(function (feature) {
                                    if (feature.featureId === selectable.key) {
                                        newArrayOfSelectables.push(selectable);
                                    }
                                });
                            });
                            return newArrayOfSelectables;
                        });
                        setProductBuildFeatureOptionSelections(featureSelections);
                        parsedStorage === null || parsedStorage === void 0 ? void 0 : parsedStorage.forEach(function (storedFeature) {
                            var _a;
                            if (newNext.key === storedFeature.featureId) {
                                (_a = newNext === null || newNext === void 0 ? void 0 : newNext.options) === null || _a === void 0 ? void 0 : _a.forEach(function (option) {
                                    var _a;
                                    var isRangeOption = (option === null || option === void 0 ? void 0 : option.range) !== undefined && (option === null || option === void 0 ? void 0 : option.range) !== null;
                                    if (option.optionCode === storedFeature.optionCode ||
                                        (isRangeOption && validateRangeInput(option.range, (_a = storedFeature === null || storedFeature === void 0 ? void 0 : storedFeature.optionCode) !== null && _a !== void 0 ? _a : ''))) {
                                        setIsAutoBuild(true);
                                        featureSelections.push({
                                            featureId: storedFeature.featureId,
                                            optionCode: option.optionCode,
                                        });
                                        var rangeOptionProductNbr = isRangeOption &&
                                            replaceProductNbrPlaceholder(option.productNbr, '{}', storedFeature.optionCode);
                                        setProductNumber(isRangeOption && rangeOptionProductNbr ? rangeOptionProductNbr : option.productNbr);
                                        if (val > 0) {
                                            setSnackbarAlert({
                                                message: "Building with option '".concat(passedOption.optionCode, "' in storage"),
                                                type: 'success',
                                            });
                                        }
                                        var newPassedProductNumber = isRangeOption && rangeOptionProductNbr ? rangeOptionProductNbr : option.productNbr;
                                        var newOption = isRangeOption && rangeOptionProductNbr
                                            ? __assign(__assign({}, option), { productNbr: rangeOptionProductNbr, optionCode: storedFeature.optionCode }) : option;
                                        beginAutoBuild({
                                            featureSelections: featureSelections,
                                            passedProductNumber: newPassedProductNumber,
                                            passedOption: newOption,
                                            val: val + 1,
                                        });
                                    }
                                });
                            }
                        });
                        setIsAutoBuild(false);
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    var fireOption = function (option, feature) {
        sessionStorage.setItem('tableData', JSON.stringify((validationData === null || validationData === void 0 ? void 0 : validationData.body).features));
        var newProductNumber = option.productNbr;
        var newArray = [];
        setProductBuildFeatureOptionSelections(function (prevVal) {
            var index = prevVal.findIndex(function (selectedFeature) { return selectedFeature.featureId === feature.featureId; });
            var slicedArray = prevVal.slice(0, index);
            slicedArray.push({ featureId: feature.featureId, optionCode: option.optionCode });
            newArray = slicedArray;
            return slicedArray;
        });
        setProductNumber(newProductNumber !== null && newProductNumber !== void 0 ? newProductNumber : '');
        setIsAutoBuild(true);
        beginAutoBuild({
            passedProductNumber: newProductNumber !== null && newProductNumber !== void 0 ? newProductNumber : '',
            featureSelections: newArray,
            passedOption: option,
            val: 0,
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ className: styles.titleContainer }, { children: [_jsx(Typography, __assign({ variant: "h1", className: styles.pageTitle }, { children: "Product Build" })), _jsx(Box, __assign({ className: styles.buttonContainer }, { children: _jsx(StyledButton, { label: "Back to Results", handleClick: function () { return navigate("/product-build/search/".concat(sessionStorage.getItem('searchTerm'))); }, widthFromProps: 130 }) }))] })), _jsx(StyledSearchWithDateAndTimeInput, { searchTerm: searchText, handleSearchButtonClick: handleButtonClick, handleInputValueChange: handleInputValueChange, disableClick: disableSubmit || searchText.length < 1, fieldIsInError: textFieldIsInError && isProductId && !isProductNumber, handleProductBuildResetClick: handleProductBuildResetClick, productBuild: true, disableResetButton: !enableReset || isAutoBuild }), (isAutoBuild || (!validationData && isLoading)) && (_jsx(Box, __assign({ className: styles.loadingSpinnerContainer }, { children: _jsx(LoadingSpinner, { indicatorSize: 10 }) }))), _jsx(ProductBuildContext.Provider, __assign({ value: isLoading }, { children: validationData && validationData.status === 200 ? (_jsx(Box, __assign({ className: styles.dataContainer, sx: { display: showProductData ? '' : 'none' } }, { children: _jsxs(_Fragment, { children: [_jsx(ProductValidationHeader, { validationData: validationData, productNumber: productNumber, productBuild: true }), _jsx(Box, __assign({ className: styles.validationFeatureGridContainer }, { children: _jsx(ValidationFeatureGrid, { features: validationData.body.features, nextFeature: validationData.body.nextFeature, handleOptionRowClickInParent: handleFeatureBuildOptionClick, productBuild: true, selectableFeatureOptions: selectableFeatureOptions, fireNewOptionInParent: fireOption, isProductBuildInError: isProductBuildInError, isAutoBuild: isAutoBuild }) }))] }) }))) : (_jsx(Typography, __assign({ variant: "h1", style: { display: isLoading ? 'none' : 'unset', marginLeft: '20px' } }, { children: showProductData ? erroredSearchText : '' }))) }))] }));
}
export var ProductBuildContext = createContext(true);
